import React, { useState } from 'react';
import { TruckIcon } from '@heroicons/react/24/outline';
import { Tooltip } from '../common/Tooltip';
import { Order } from '../../types/order';
import OrderToDeliveryNoteModal from './OrderToDeliveryNoteModal';

interface OrderToDeliveryNoteButtonProps {
  order: Order;
  onDeliveryNoteCreated?: (deliveryNoteId: string) => void;
  showTooltip?: boolean;
  className?: string;
  disabled?: boolean;
}

/** Szállítólevél készítése megrendelésből – modal, amelyben a mennyiségek, raktár és készletlevonás állítható. */
const OrderToDeliveryNoteButton: React.FC<OrderToDeliveryNoteButtonProps> = ({
  order, onDeliveryNoteCreated, showTooltip = true, className = 'text-gray-400 hover:text-blue-400', disabled = false
}) => {
  const [open, setOpen] = useState(false);
  const remaining = (order.items || []).reduce((s, it) => s + Math.max(0, (Number(it.quantity) || 0) - (Number(it.deliveredQuantity) || 0)), 0);
  const done = remaining <= 0 && (order.items || []).length > 0;

  const button = (
    <button
      type="button"
      onClick={(e) => { e.stopPropagation(); if (!disabled) setOpen(true); }}
      disabled={disabled}
      className={`${className} flex items-center transition-colors ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      aria-label="Szállítólevél készítése"
    >
      <TruckIcon className="h-4 w-4 mr-1" />
      <span className="text-xs font-medium">{done ? 'Szállítva' : 'Szállítólevél'}</span>
    </button>
  );

  return (
    <>
      {showTooltip && !disabled ? <Tooltip content={done ? 'Minden tétel kiszállítva – új szállítólevél csak pótlásra' : 'Szállítólevél készítése a megrendelésből'}>{button}</Tooltip> : button}
      {open && (
        <OrderToDeliveryNoteModal
          isOpen
          order={order}
          onClose={() => setOpen(false)}
          onCreated={(id) => onDeliveryNoteCreated?.(id)}
        />
      )}
    </>
  );
};

export default OrderToDeliveryNoteButton;
